// extracted by mini-css-extract-plugin
export default {"container":"_LoginTabContentStyles_container__4l4ht","form-group":"_LoginTabContentStyles_form-group__sdjbL","error":"_LoginTabContentStyles_error__l0bVZ"};